import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import { BASE_URL, TOKEN, CURRENT_IP } from "../../helper/BASE_URL";

export default function Directs() {
  const [data, setData] = useState([]);

  const { t } = useContext(TranslatorContext);

  useEffect(() => {
    Get_Data();
  }, []);

  const Get_Data = () => {
    const getDta = localStorage.getItem("jwt");
    const parseIT = JSON.parse(getDta);

    try {
      axios
        .post(
          BASE_URL + "get_bounty_log.php",
          {
            userid: parseIT.reg_em,
            token: parseIT.boss_token,
            ip_addr: window.localStorage.getItem('bpipos')?window.localStorage.getItem('bpipos'):'224.234.50.218',
            bounty_no: "1",
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          console.log(acc.data);
          // setData(acc.data.data.bounty_purchase_list);
          if (acc.data.data.bounty_purchase_list[0] !== "NO RECORDS FOUND") {
            setData(acc.data.data.bounty_purchase_list)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <PageLayout>
      <div className="mc-card">
        <div className="mc-breadcrumb">
          <h3 className="mc-breadcrumb-title">{t("Bounty Tickets")}</h3>
          <ul className="mc-breadcrumb-list">
            <li className="mc-breadcrumb-item">
              <Link to="#" className="mc-breadcrumb-link">
                {t("home")}
              </Link>
            </li>
            <li className="mc-breadcrumb-item">{t("Bounty Tickets")}</li>
          </ul>
        </div>
      </div>
      <div className="mc-card p-sm-5">
        <table className="mc-table">
          <thead className="mc-table-head">
            <tr>
              <th>S.N.</th>
              <th>Bounty Name</th>
              <th>Bounty Ticket</th>
              <th>Purchase date</th>
            </tr>
          </thead>
          <tbody className="mc-table-body">
            {data.map((hit, index) => {
              return (
                <tr key={index}>
                  <td style={{ width: "5%" }}>{index + 1}</td>
                  <td>{hit.bounty_name}</td>
                  <td>{hit.bounty_ticket}</td>
                  <td>{hit.purchase_date}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {
            data.length == 0 &&
            <p style={{textAlign:"center",marginTop:15,fontWeight:"bolder"}}>No Data Found</p>
          }
      </div>
    </PageLayout>
  );
}
